import { useState, useEffect, useCallback } from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import {endpoints} from "@api/apis";
import {useAppDispatch, useAppSelector} from "@store/hooks";
import {RootState} from "@store/newstore";
import { useIsFocused } from "@react-navigation/native";
import { updatePartnerParams } from "@app/store/slices/platformSlice";

export const usePledgeData = () => {
    const [pledgeData, setPledgeData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const userDetails = useAppSelector((state: RootState) => state.auth.userDetails);
    const isFocused = useIsFocused();
    const dispatch = useAppDispatch();

    const fetchPledgeData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const applicationIdStored = await AsyncStorage.getItem("application_id");
            const application_id = applicationIdStored ?? userDetails?.linkedApplications[0]?.applicationId;
            const response = await axios.get(`${endpoints.pledgeData}${application_id}`);
            setPledgeData(response.data);
        } catch (err: any) {
            setError(err?.message || "Failed to fetch enabled RTA");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
          if(isFocused) {
            fetchPledgeData();
          }
    }, [fetchPledgeData, isFocused]);

    return { pledgeData, loading, error, refetch: fetchPledgeData };
};